import { useScrmFetch } from "@/hooks/common/fetch/useFetch";
import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';
import { useFirstUpperCase } from "@/hooks/common/useUtils";

import useProductApi from "@/hooks/shopify-hooks/api/useProductApi";

const brand = useFirstUpperCase(process.env.BRAND);
const site = document.body.dataset.originalSite?.toLocaleUpperCase();
const { domain } = shopifyConst;
// 产品注册接口
export const useProductSalesMsg = async (params = {}) => {

	return await useScrmFetch(`/web/iscrm-edm/shopifyApi/getGAcount`).post(JSON.stringify([{
		...params,
		domain,
		brand,
		site
	}])).json();
}

// 获取edm 热销产品 modelnumber
export const useHotSaleProduct = async (params = {}) => {
	return await useScrmFetch(`/web/iscrm-edm/shopifyApi/getHotSaleProductFromGS`).post(JSON.stringify([{
		...params,
		domain,
		brand,
		site
	}])).json();
}

// 获取产品ID
const getProductId = async (model) => {
	const result = await useProductApi(model);
	const productId = result.data?.product?.id ? result.data?.product?.id.split('/').pop() : null;
	return productId;
};

// 获取销售信息
export const getSalesMsg = async (type,model, id) => {
	const parames = {
		modelNumber: model,
		productId: id,
		desctoAssistSales:type
	};

	if (!id) {
		const productId = await getProductId(model);
		if (!productId) {
			return;
		}
		parames.productId = productId;
	}

	return useProductSalesMsg({
		modelNumberList: [
			parames
		],
	});
};

window.igws = window.igws ?? {};
window.igws.utils = window.igws.utils ?? {};
window.igws.utils.getSalesCount = getSalesMsg;